import React from "react";
import sponserOne from "../../assets/images/client-logo/nfi.png";
import sponserTwo from "../../assets/images/client-logo/victron.png";
import sponserThree from "../../assets/images/client-logo/vumc.png";
import sponserFour from "../../assets/images/client-logo/lijnco.png";
import sponserFive from "../../assets/images/client-logo/prisma_direct.png";
import sponserSix from "../../assets/images/client-logo/erasmus.png";
import SliderCom from "../helpers/SliderCom";

export default function Customers() {
    const settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        speed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };
    return (
        <div className="client-logo-area">
            <div className="container">
                <div className="logo-carousel-wrap pt-100 pb-90">
                    <SliderCom settings={settings}>
                        <div className="logo-item">
                            <img src={sponserOne} alt="Client Logo" />
                        </div>
                        <div className="logo-item">
                            <img src={sponserTwo} alt="Client Logo" />
                        </div>
                        <div className="logo-item">
                            <img src={sponserThree} alt="Client Logo" />
                        </div>
                        <div className="logo-item">
                            <img src={sponserFour} alt="Client Logo" />
                        </div>
                        <div className="logo-item">
                            <img src={sponserFive} alt="Client Logo" />
                        </div>
                        <div className="logo-item">
                            <img src={sponserSix} alt="Client Logo" />
                        </div>
                    </SliderCom>
                </div>
                <hr />
            </div>
        </div>
    );
}